import { actionCreator } from 'utils';
import * as RollsInTypes from '../types/rollInTypes';

// L O A D   R O L L S   I N
export function loadRollsIn() {
    return {
        type: RollsInTypes.LOAD_ROLLS_IN,
    };
}

export function loadRollsInRes(data) {
    return {
        type: actionCreator(RollsInTypes.LOAD_ROLLS_IN, 'res'),
        data,
    };
}

export function loadRollsInErr() {
    return {
        type: actionCreator(RollsInTypes.LOAD_ROLLS_IN, 'err'),
    };
}
// L O A D   R O L L S   I N

// S E T   R O L L S   I N   F I L T E R   &   P A G I N A T I O    &   R E S E T
export function setRollInFilters(key, value) {
    return {
        type: RollsInTypes.SET_ROLLS_IN_FILTER,
        key,
        value,
    };
}

export function setRollInPagination(key, pagination) {
    return {
        type: RollsInTypes.SET_ROLLS_IN_PAGINATION,
        key,
        pagination,
    };
}

export function setRollInSort(sort) {
    return {
        type: RollsInTypes.SET_ROLLS_IN_SORT,
        sort,
    };
}

export function resetRollInFilters() {
    return {
        type: RollsInTypes.RESET_ROLLS_IN_FILTERS,
    };
}
// S E T   R O L L S   I N   F I L T E R   &   P A G I N A T I O N  &   R E S E T

// C H A N G E   R O L L   I N   S T A T U S
export function changeRollInStatus(id) {
    return {
        type: RollsInTypes.CHANGE_ROLL_IN_SRTATUS,
        id,
    };
}

export function changeRollInStatusRes(data) {
    return {
        type: actionCreator(RollsInTypes.CHANGE_ROLL_IN_SRTATUS, 'res'),
        data,
    };
}
// C H A N G E   R O L L   I N   S T A T U S
